export default "__VITE_ASSET__DK3pljyn__";